module.exports = __webpack_public_path__ + "42261ad2f818578bfe12ad2434158f96.MP3";